import _ from "lodash";
import React, { useMemo } from "react";
import { Select } from "semantic-ui-react";
import MultiSelect from "./MultiSelect";

interface SelectOption {
  id: string;
  key: string;
  value: string;
}
interface IJsonApiDataSelect<T, D = any> {
  path?: string | ((data: D) => T[]);
  multiple?: boolean;
  labelled?: boolean;
  query: { isLoading: boolean; data: D };
  clearOption?: SelectOption;
  staticOptions?: Array<SelectOption>;
  filterOptions?: (item: T) => boolean;
  toOptions: (item: T) => SelectOption;
}

export const JsonApiDataSelect = <T, D = any>({
  labelled,
  multiple,
  query,
  filterOptions,
  staticOptions,
  clearOption,
  toOptions,
  path,
  ...selectProps
}: IJsonApiDataSelect<T, D>) => {
  const { isLoading, data } = query;
  const options = useMemo(() => {
    const items = typeof path === "function" ? path(data) ?? [] : (_.get(data, path ?? "payload.data", []) as T[]);

    return items.filter(filterOptions || (() => true)).map(toOptions);
  }, [data, filterOptions, toOptions]);
  const finalOptions = useMemo(() => {
    return _.compact([clearOption, ...(staticOptions || []), ...options]);
  }, [clearOption, staticOptions, options]);

  if (multiple) {
    return <MultiSelect options={finalOptions} loading={isLoading} {...selectProps} />;
  }
  return <Select options={finalOptions} loading={isLoading} multiple={labelled} {...selectProps} search />;
};

export default JsonApiDataSelect;
